import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Search } from 'react-bootstrap-icons';
import { ReactNode } from 'react';


interface SmallCopyBlockProps {
    copyText?: string;
    link?: string;
    styling?: string;
    children?: ReactNode;
    /*onSelectItem: (item: string) => void;*/
}

function SmallCopyBlock({copyText, styling, link, children}: SmallCopyBlockProps){
    return (
        <> 
            <p className={"smallest-copy-style text-font-body m-0 " + styling}>{copyText}{children}</p>
        </>
    )
}

export default SmallCopyBlock;